import type { ModelProductOperation } from '@app/api/Products';
import type { Options } from '@app/types';

import type { PaginationProps } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { Dayjs } from 'dayjs';
import type { NoUndefinedRangeValueType } from 'rc-picker/lib/PickerInput/RangePicker';
import type { ChangeEventHandler, FC } from 'react';

export interface OperationsFilters {
  SearchTerm: string;
  SearchBy: SearchType;
  range: NoUndefinedRangeValueType<Dayjs> | null;
  warehouses: Options;
  operationTypes: Options;
  products: Options;
}

export enum SearchType {
  Products = 'products',
  Suppliers = 'suppliers',
}

interface OperationsTableProps {
  columns: ColumnsType<ModelProductOperation>;
  data: ModelProductOperation[];
  pagination: Pagination;
  isPageLoading: boolean;
  isFetching: boolean;
  onPaginate: PaginationProps['onChange'];
}

interface FiltersProps {
  warehousesOptions: Options;
  operationTypesOptions: Options;
  productsOptions: Options;
  disabled?: boolean;
  values: OperationsFilters;
  onFilterChange: FilterChangeType;
  onChangeSearchTerm: ChangeEventHandler<HTMLInputElement>;
  skipFilters: () => void;
  onSearch: () => void;
}

export interface UseWarehouseOperationsEffectsProps {
  filtersListsHandler(): void;
  searchProductOperationsHandler(): Promise<void>;
}

export type FilterChangeType = (
  key: keyof OperationsFilters,
  value: OperationsFilters[typeof key]
) => void;

export interface Pagination {
  ItemsPerPage: number;
  Page: number;
  Total: number;
}

export type GetColumnsType = (props: {
  openDocument(id: number): void;
  openProduct(id: number): void;
  openRecord(id: number): void;
  openUser(id: number): void;
}) => ColumnsType<ModelProductOperation>;

export interface GetMenuItemsProps {
  IsProductItemsAccept: boolean;
  IsProductItemsDecomission: boolean;
  IsProductItemsMove: boolean;
  IsProductItemsDelete: boolean;
}
export type FiltersType = FC<FiltersProps>;
export type OperationsTableType = FC<OperationsTableProps>;
